import { render } from "./TabNavigation.vue?vue&type=template&id=7292686c&scoped=true"
import script from "./TabNavigation.vue?vue&type=script&lang=js"
export * from "./TabNavigation.vue?vue&type=script&lang=js"

import "./TabNavigation.vue?vue&type=style&index=0&id=7292686c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7292686c"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab});
